import { Pipe, PipeTransform } from '@angular/core';
import { InfiniteListItemWidth } from '@fleet-beat/infinite-list';

@Pipe({
  name: 'infiniteListItemWidth',
})
export class InfiniteListItemWidthPipe implements PipeTransform {
  transform(width: string | InfiniteListItemWidth | undefined, screen: 'md' | 'lg' | 'sm' | 'xs'): string {
    if (!width) {
      return '100%';
    }
    if (typeof width === 'string') {
      return width;
    }
    const config: InfiniteListItemWidth = width as InfiniteListItemWidth;
    return config[screen] || config.md || '100%';
  }
}
